// extracted by mini-css-extract-plugin
export default {"content":"hkEUJ","webview":"S6euu","body":"HOu9a","iframeModal":"eJzlX","income":"ExrU7","balance":"_2zfHv","skeleton-progress":"xcL8l"};